module.exports = new __parcel__URL__("enhancedresilience.3ef06ce4.png").toString();